import {
  Attribute,
  ChangeDetectorRef,
  ComponentFactoryResolver,
  Directive,
  ViewContainerRef,
} from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'rtc-detached-router-outlet',
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class DetachedRouterOutlet extends RouterOutlet {
  private cdRef: ChangeDetectorRef;

  constructor(
    parentContexts: ChildrenOutletContexts,
    location: ViewContainerRef,
    resolver: ComponentFactoryResolver,
    // eslint-disable-next-line @angular-eslint/no-attribute-decorator
    @Attribute('name') name: string,
    changeDetector: ChangeDetectorRef,
  ) {
    super(parentContexts, location, resolver, name, changeDetector);
    this.cdRef = changeDetector;
  }

  public activateWith(): void {
    super.activateWith.apply(this, arguments);
    this.cdRef.detectChanges();
  }
}
